export default {
  title: 'Card Simple Text'
}

const Template = args => `
  <cradlepoint-container max-width="600px">
    <cradlepoint-card-simple-text class="bg-charcoal20">
      ${args['content'] && args['content']}
    </cradlepoint-card-simple-text>
  </cradlepoint-container>
`;

export const Default = Template.bind({});

Default.args = {
  content: `
    <p class="text-charcoal">
      Three links and multi-failover for critical comms at fixed sites
    </p>
    <p class="text-charcoal">
      When healthcare or the ability to process payments hang in the balance,
      relying on just one type of WAN link isn't sufficient. A highly manageable
      solution that supports and intelligently orchestrates cellular, sattelite,
      and wired connectivity is the best way to stay flexible, no matter where
      the site is and what the applications are.
    </p>
  `
}
